import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { StartingDataTable } from '../StartingDataTable';
import { startingDataNote } from '../../data/startingData';
import { CONTACT } from '../../data/navigation';
export function StartingData() {
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const node = sectionRef.current;
    if (!node || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          node.setAttribute('data-analytics-viewed', 'true');
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.25
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);
  return <section id="starting-data" ref={sectionRef} aria-labelledby="starting-data-heading" data-analytics="starting-data-view" className="w-full bg-warm" data-id="element-345" data-mp="13orer62zqiqe">
      <div className="mx-auto max-w-shell px-5 py-16 lg:px-10 lg:py-24" data-id="element-346" data-mp="2rqjdhzmbdtao">
        <SectionHeading id="starting-data-heading" eyebrow="PUBLISHED STARTING GUIDANCE" heading="Starting data by material" intro="Starting points from the Shear Geometry catalog. Speed is in surface feet per minute, depth of cut is per side in inches, and feed is in inches per revolution." data-id="element-347" data-mp="2d2yful87kma5" />

        <div className="mt-12" data-id="element-348" data-mp="28558hov65m8a">
          <StartingDataTable linkMaterials data-id="element-349" data-mp="281922xtlpuid" />
        </div>

        <div className="rp-measure mt-8 border-l-2 border-copper pl-5 text-[13.5px] leading-[1.7] text-graphite/85" data-id="element-350" data-mp="1u544w1nis0p4">
          <p data-id="element-351" data-mp="1z35p4pwom626">{startingDataNote}</p>
          <p className="mt-2" data-id="element-352" data-mp="3oi3hrn0imgsp">
            Technical assistance:{' '}
            <a href={CONTACT.techPhoneHref} data-analytics="phone-click" data-analytics-line="technical" data-analytics-location="starting-data" className="whitespace-nowrap font-medium text-navy underline decoration-copper underline-offset-2" data-id="element-353" data-mp="3ofr07ayo68g6">
              {CONTACT.techPhoneLabel}
            </a>
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-x-8 gap-y-2" data-id="element-354" data-mp="3i3ep9abw0bj5">
          <Link to="/technical-resources/starting-data/" className="inline-flex min-h-[44px] items-center gap-2 border-b border-copper text-[14px] font-semibold text-navy hover:text-copper" data-id="element-355" data-mp="3d3s9ou8l6j76">
            Starting Data reference
            <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-356" data-mp="4ujpyce8agd8" />
          </Link>
          <Link to="/technical-resources/safety/" className="inline-flex min-h-[44px] items-center gap-2 border-b border-copper text-[14px] font-semibold text-navy hover:text-copper" data-id="element-357" data-mp="3w1cu9p4bivlz">
            Workholding chart
            <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-358" data-mp="sj2zev90kz6w" />
          </Link>
        </div>
      </div>
    </section>;
}